import { VisualizationTypes } from 'reporting-data/tsTypes/visualization';
import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { EncodingOptions } from '../formatting/FormattingRecords';
export const Events = checked.record({
  onPointClick: checked.func().optional()
}, 'Events');
export const GaugeBand = checked.record({
  to: checked.number().optional(),
  from: checked.number().optional(),
  color: checked.string().optional()
}, 'GaugeBand');
export const GaugePlot = checked.record({
  min: checked.number().optional(),
  max: checked.number().optional(),
  bands: checked.list(GaugeBand).optional()
}, 'GaugePlot');
export const GaugeReferenceLine = checked.record({
  value: checked.number().optional(),
  label: checked.string().optional()
}, 'GaugeReferenceLine');
export const GaugeLayer = checked.record({
  name: checked.string().optional(),
  dataset: checked.string(),
  field: checked.string().optional(),
  plot: GaugePlot.optional(),
  showRangeLabels: checked.boolean().defaultValue(true),
  dataColumn: checked.string(),
  targetColumn: checked.string().optional(),
  compareColumn: checked.string().optional(),
  valueFormattingOptions: EncodingOptions.optional(),
  referenceLineValues: checked.list(GaugeReferenceLine).optional()
}, 'GaugeLayer');
export const GaugeStyles = checked.record({
  legendPosition: checked.string().optional(),
  legendWidth: checked.string().optional()
}, 'GaugeStyles');
export const GaugeVisualizationRecord = checked.record({
  type: checked.string().always(VisualizationTypes.GAUGE),
  data: checked.map(Dataset),
  events: Events.optional(),
  layer: GaugeLayer,
  style: GaugeStyles
}, 'GaugeVisualizationRecord');